import React, { Component } from 'react';
import { connect } from 'react-redux';

class BreadCrumbs extends Component {

    constructor(props) {
        super(props);
    }

    /* Function to return the breadCrumb link according to the component */
    crumbLink(bread, count = 0, length = '') {
        let link;
        if (length == 1) {
            let className = "first-upper breadcumb-underline"
            if (bread.text == 'My earthDECK') {
                className = 'breadcumb-underline';
            }
            link = <span className={className}>{bread.text}</span>
        } else if (length == 2) {
            if (count == 0) {
                link = <a href="/dashboard" className="breadcumb-underline">{bread.text}</a>
            } else {
                link = <span className="first-upper breadcumb-underline">{bread.text}</span>
            }
        } else {
            if (count == 0) {
                link = <a href="/dashboard" className="breadcumb-underline">{bread.text}</a>
            } else if (count == 1) {
                link = <a href={`/dashboard/${bread.id}/${bread.text}`} className="first-upper breadcumb-underline">{bread.text}</a>
            } else {
                let className = "first-upper breadcumb-underline"
                if (bread.text == 'My earthDECK') {
                    className = 'breadcumb-underline';
                }
                link = <span className={className}>{bread.text}</span>
            }
        }
        return link;
    }

    /**
     * Render the component
     * @returns {*}
     */
    render() {
        const breadCrumbs = (this.props.breads) ? this.props.breads : [];
        if (breadCrumbs.length > 0) {
            return (
                <div className="breadcumb">
                    {breadCrumbs.map((bread, index) => {
                        return <span key={`bread_${index}`}>
                            {(index ? ' > ' : '')}
                            {this.crumbLink(bread, index, breadCrumbs.length)}
                        </span>;
                    })}
                </div>
            );
        }
    }
}
function mapStateToProps(state) {
    return {

    };
}

export default connect(mapStateToProps, {})(BreadCrumbs);



// WEBPACK FOOTER //
// ./components/Common/BreadCrumbs.js